// extracted by mini-css-extract-plugin
export default {"wrap":"DataTable_wrap__347YO","table":"DataTable_table__rQI6i","empty":"DataTable_empty__ptHQI","sticky":"DataTable_sticky__puBra","hoverable":"DataTable_hoverable__BJpRa"};